export const HeaderDetails={
    HEADER_TEXT:'Session Details',
    DATE:'Date',
    TIME:'Time',
    METHOD_OF_SESSION:'Method of Session',
    CARDIOLOGIST_NAME:'Cardiologist Name',
    METHOD_OF_CONSULTATION:'Method of Consultation',
    CARDIOLOGIST:'Cardiologist',
    MEDICAL_HISTORY: 'Medical History',
    FAMILY_HISTORY:'Family History',
    MEDIACATIONS:'Medications',
    SOCIAL_HISTORY:'Social History',
    SURGICAL_HISTORY:'Surgical History',
    PATIENT_PROVIDED_DETAILS:'Patient Provided Details',
    REASON_FOR_CONSULTATION:'Reason for Consultation',
    SYMPTOMS:'Symptoms',
    NOTES_FOR_CARDIOLOGIST:'Notes for Cardiologist',
    SESSION_NOTES:'Provider  Notes',
    SESSION_DETAILS:'Write you personal notes here. They will not be shared with the patient.',
    REPORT_NOTES:'Report Documentation',
    REPORT_DETAILS:'Write your recommendations to the patient here.',
    BLODD_PRESSURE_HISTORY:'Blood Pressure 30 Days History',
    UNABLE_TO_PROCESS_REQUEST:'Unable to process this request due to internal server error.',
    INTERNAl_SERVER_ERROR:'Unable to process this request due to internal server error',
    NOTES_SUCESSFULL:'You’re all set” - “Session notes successfully completed',
    SESSION_STATUS_CHANGED:'Session status changed successfully',
    COMPLETE_SESSION_FINALIZE:'Session Not Complete - Click “Complete Session” to finalize documentation'
}

export const Patient_Status={
    PATIENT_NO_SHOW:'Patient No Show',
    MEMBER_TECHNICAL_ISSUE  :'Member Technical Issue',
    PROVIDER_TECHNICAL_ISSUE :'Provider Technical Issue',
    MEMBER_DECLINED:'Member Declined',
    SYSTEM_CLOSED :' System Closed'
}

export const Call_Status={
    VIDEO_CALL:'Video Call',
    AUDIO_CALL  :'Audio Call',
    BACKUP_CALL :'Backup Call',
   OTHER:'Other',
   FOLLOW_UP:'Follow-up',
   NO_FOLLOW_UP:'No Follow-up',
   THREE_DAYS:'3 Days',
   ONE_WEEK:'1 Week',
   TWO_WEEK:'2 Weeks',
   ONE_MONTH:'1 Month'
}

export const Visit_Types={
    EKG:"EKG",
    OTHER:"OTHER",
    MEDICAL:"MEDICAL",
    BLOOD:"BLOOD",
    LIFESTYLE:"LIFESTYLE",
    CLINICIAN:"CLINICIAN"
}

export const Notes_Details={
    PROVIDER_NOTES:'Provider Notes',
    PROVIDERNOTE:'providerNotes',
    NOTES_FOR_APPOINTMENT:'Add your notes for an appointment here.',
    CONSULTATION_LABEL:'Consultation Summary',
    CONSULTATION_NAME:'consultationSummary',
    CONSULTATION_PLACEHOLDER:'Write your consultant summary here. This will be sent to the patient',
    RECOMMENDEDACTION_LABEl:'Recommended Action',
    RECOMMENDEDACTION_NAME:'recommendedAction',
    RECOMMENDEDACTION_PLACEHOLDER:'"Write your recommended actions here. This will be sent to the patient',
    SESSION_STATUS:'Session Status',
    SESSION_STATUS_HELPERTEXT:'Required*',
    INCOMPLETE:'Incomplete',
    METHOD: 'Method',
    PREVIEW_REPORT:'Preview Report',
    COMPLETE_SESSION:'Complete Session'
}